import React from 'react';
import { Building2, Home, Palette, Hammer, Truck, Scale } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const iconMap = {
  0: Building2,
  1: Home,
  2: Palette,
  3: Hammer,
  4: Truck,
  5: Scale
};

const Services = ({ t }) => {
  const services = t.services.items;
  
  return (
    <section id="services" className="py-32 bg-gradient-to-b from-black via-gray-950 to-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 luxury-pattern" />
      <div className="absolute top-0 left-1/2 w-full h-full bg-gradient-to-r from-transparent via-gold/5 to-transparent" />
      
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20 space-y-4">
          <div className="inline-block">
            <Badge className="bg-gold/20 text-gold border-gold/30 px-4 py-1">
              SERVIÇOS
            </Badge>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white heading-luxury">
            {t.services.title}
          </h2>
          <div className="section-divider" />
          <p className="text-gray-400 text-lg max-w-3xl mx-auto">
            {t.services.subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => {
            const Icon = iconMap[index];
            return (
              <Card 
                key={service.id} 
                className="group bg-gradient-to-br from-gray-900 to-black border-gold/20 hover:border-gold transition-all duration-500 luxury-card-hover overflow-hidden relative"
              >
                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-bl from-gold/10 to-transparent" />
                
                <CardContent className="p-8 space-y-6 relative z-10">
                  <div className="flex items-start justify-between">
                    <div className="w-16 h-16 bg-gradient-to-br from-gold to-gold-light rounded-xl flex items-center justify-center group-hover:scale-110 group-hover:rotate-6 transition-all duration-500 shadow-lg">
                      <Icon className="h-8 w-8 text-black" />
                    </div>
                    <div className="text-7xl font-bold text-gold/10 heading-luxury">
                      {String(index + 1).padStart(2, '0')}
                    </div>
                  </div>
                  
                  <div className="space-y-3">
                    <h3 className="text-xl font-bold text-white heading-luxury group-hover:text-gold transition-colors">
                      {service.title}
                    </h3>
                    <div className="h-0.5 w-12 bg-gold group-hover:w-full transition-all duration-500" />
                    <p className="text-gray-400 leading-relaxed text-sm">
                      {service.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;